import e from "react";
import { sanitize as f } from "lettersanitizer";
const u = e.memo(({ className: t, html: n, iframeTitle: i, rewriteExternalLinks: m, rewriteExternalResources: o, allowedSchemas: c, preserveCssPriority: a, text: l, useIframe: d }) => {
  const r = f(n, l, {
    rewriteExternalResources: o,
    rewriteExternalLinks: m,
    allowedSchemas: c,
    preserveCssPriority: a
  });
  return d ? e.createElement(
    "div",
    { className: t },
    e.createElement("iframe", { srcDoc: r, title: i })
  ) : e.createElement("div", { className: t, dangerouslySetInnerHTML: { __html: r } });
});
export {
  u as Letter
};
